export const PROJECT_PICKLIST_LOADING = 'PROJECT_PICKLIST_LOADING'
export const PROJECT_PICKLIST_FAILURE = 'PROJECT_PICKLIST_FAILURE'
export const SET_PROJECT_PICKLIST_DATA = 'SET_PROJECT_PICKLIST_DATA'
export const SET_ROWS_COUNT = 'SET_ROWS_COUNT'
export const PICKLIST_CHECKBOX_CHANGE = 'PICKLIST_CHECKBOX_CHANGE'